import { createContext, useContext, useEffect, useState } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { configSettings } from '@/lib/config';

const StripeContext = createContext<Stripe | null>(null);

/**
 * Provider that initializes and shares a single Stripe instance across the app
 */
export function StripeProvider({ children }: { children: React.ReactNode }) {
    const [stripe, setStripe] = useState<Stripe | null>(null);

    useEffect(() => {
        if (configSettings.stripePlatformKey) {
            loadStripe(configSettings.stripePlatformKey).then(setStripe);
        }
    }, []);

    return <StripeContext.Provider value={stripe}>{children}</StripeContext.Provider>;
}

/**
 * Hook to access the Stripe instance
 * Must be used within StripeProvider
 */
export function useStripe() {
    const context = useContext(StripeContext);
    return context;
}
